import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { faqs } from '../data/faq';
import { SectionHeading } from './SectionHeading';
export function Faq() {
  const {
    t
  } = useLanguage();
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);
  return <section id="faq" className="bg-white" data-id="element-117" data-mp="2dzxtw90xqfjq">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-118" data-mp="291d1uwvu726d">
        <SectionHeading kicker={t(copy.faqKicker)} title={t(copy.faqTitle)} data-id="element-119" data-mp="28za7y1rkcowd" />

        <ul className="mx-auto mt-12 max-w-3xl divide-y divide-navy/10 border-y border-navy/10" data-id="element-120" data-mp="240p5rwsr3v5a">
          {faqs.map(faq => {
          const open = openId === faq.id;
          return <li key={faq.id} data-id="element-121" data-mp="soo9lwtk54fi">
                <h3 data-id="element-122" data-mp="no09mlncpd95">
                  <button type="button" onClick={() => setOpenId(open ? null : faq.id)} aria-expanded={open} aria-controls={`faq-panel-${faq.id}`} className="flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-123" data-mp="nniextgc773c">
                    <span className="font-display text-base font-bold text-navy" data-id="element-124" data-mp="fj8gbidhc19f">
                      {t(faq.question)}
                    </span>
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-mist text-royal" data-id="element-125" data-mp="6rq2he409xji">
                      {open ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-126" data-mp="bjhln3ku10zm" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-127" data-mp="3t0hhho62th8c" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-128" data-mp="3jz9n3h6ol0jj">
                  {open ? <motion.div id={`faq-panel-${faq.id}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-129" data-mp="3nztiogblvw3k">
                      <p className="pb-6 pr-12 text-sm leading-relaxed text-charcoal/70" data-id="element-130" data-mp="1fsztyfyg47dh">
                        {t(faq.answer)}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}